import React from 'react';
import { useIsMobile } from '@/hooks';
import styles from './SingleMetricCard.module.scss';

interface SingleMetricCardProps {
  title: string;
  backgroundColor: string;
  detail: string;
  textColor: string;
  width?: string;
  titleFontSize?: string;
  detailFontSize?: string;
  mobileWidth?: string;
  mobileTitleFontSize?: string;
  mobileDetailFontSize?: string;
}

const SingleMetricCard: React.FC<SingleMetricCardProps> = ({
  title,
  backgroundColor,
  detail,
  textColor,
  width,
  titleFontSize,
  detailFontSize,
  mobileDetailFontSize,
  mobileTitleFontSize,
  mobileWidth,
}) => {
  const isMobile = useIsMobile();
  const appliedWidth = isMobile ? mobileWidth : width;
  const appliedTitleFontSize = isMobile ? mobileTitleFontSize : titleFontSize;
  const appliedDetailFontSize = isMobile
    ? mobileDetailFontSize
    : detailFontSize;
  return (
    <div
      className={styles.card}
      style={{ backgroundColor, width: appliedWidth }}
    >
      <div className={styles.content}>
        <div className={styles.titleContainer}>
          <span
            className={styles.title}
            style={{ color: textColor, fontSize: appliedTitleFontSize }}
          >
            {title}
          </span>
        </div>
        <span
          className={styles.detail}
          style={{ color: textColor, fontSize: appliedDetailFontSize }}
        >
          {detail}
        </span>
      </div>
    </div>
  );
};

export default SingleMetricCard;
